export enum HydrationRoles {
  empty = 0,
  onboardingProspect = 1,
  onboardingClient = 2,
  onboardingProspectOrOnboardingClient = 3,
  activeClient = 4,
  internal = 5,
}

export enum HydrationSources {
  empty = 0,
  login = 1,
  predashboard = 2,
  legacyUpgrade = 3,
  loginRememberMe = 4,
}

export interface IHydrationStatusStore {
  hydrationRole: HydrationRoles;
  hydrationSource: HydrationSources;
}
